import { useEffect, useState } from 'react'
import { mappedArray, replaceAt } from '@10000/common'
import { Box, Input } from '..'

export const Digits = ({ value, onChange, onComplete, error }) => {
  const [digits, setDigits] = useState(value || mappedArray(6, ''))

  const focusInput = (index) => setTimeout(() => {
    document.querySelector(`#digit-${index}`)?.focus()
  })

  const update = (value, i) => {
    const newDigits = Array.from(replaceAt(digits, i, value.replace(/[^0-9]/g, '')).slice(0, 6).join(''))
    newDigits.length = 6
    setDigits(newDigits)
    onChange?.(newDigits.join(''))

    const digitIndex = digits.join('').length >= newDigits.join('').length ? - 1 : 0
    focusInput(Math.min((newDigits.join('').length + digitIndex), 5))
  }

  const onKeyDown = (e, i) => {
    if(e.key === 'Backspace' && !digits[i]) {
      focusInput(i - 1 >= 0 ? i - 1 : 0)
    }
  }

  const resetFocus = () => {
    const index = digits.reduce((sum, char) => char ? sum + 1 : sum, 0)
    focusInput(index > 5 ? 5 : index)
  }

  useEffect(() => {
    if(onComplete && digits.join('').length === 6 && !error) {
      onComplete(digits.join(''))
    }
  }, [onComplete, error, digits])

  return (
    <Box fullWidth gap={8}>
      {mappedArray(6, i =>
        <Input
          key={i}
          id={`digit-${i}`}
          value={digits[i] || ''}
          type="tel"
          small
          required
          textAlign="center"
          onChange={e => update(e.target.value, i)}
          onKeyDown={e => onKeyDown(e, i)}
          onClick={resetFocus}
          error={error}
        />
      )}
    </Box>
  )
}